import styled from 'styled-components';

const PageTitle = styled.h2`
  margin: 24px 0 16px 0;
  font-size: 20px;
  font-weight: 300;
`;

export default PageTitle;
